import dedent from 'ts-dedent'
import { Provider, WorkflowComponentCodeParams, WorkflowComponentParamType } from '../types'
import { SelectSameSchemaWorkflowComponent } from './common/selectsameschemacomponent'

class Sample extends SelectSameSchemaWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.sample',
        group: 'Data Preparation',
        title: 'Sample',
        description: `
      This component generates a new table with a random sample of N rows from an input table.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'nrows',
          type: WorkflowComponentParamType.Number,
          title: 'Number of rows to sample',
          min: 1
        }
      ]
    )
    // In BQ, the output from this component cannot be optimized
    this.inputs = this.inputs.filter(
      (input) => input.providers == undefined || input.providers.includes(Provider.BigQuery)
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    const nrows = Math.floor(Number(params.nrows))
    switch (connection.type) {
      case Provider.BigQuery:
        return dedent`SELECT *
              FROM ${connection.quoteName(params.source as string)}
              ORDER BY RAND()
              LIMIT ${nrows}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */
                *
              FROM ${connection.quoteName(params.source as string)}
              ORDER BY RANDOM()
              LIMIT ${nrows}`
      case Provider.Oracle:
        return dedent`SELECT *
              FROM ${connection.quoteName(params.source as string)}
              ORDER BY DBMS_RANDOM.VALUE
              FETCH FIRST ${nrows} ROWS ONLY`
      default:
        return dedent`SELECT *
              FROM ${connection.quoteName(params.source as string)}
              ORDER BY RANDOM()
              LIMIT ${nrows}`
    }
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { Sample }
